import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-payment-partner-iframe-dialog',
  templateUrl: './payment-partner-iframe-dialog.component.html',
  styleUrls: ['./payment-partner-iframe-dialog.component.css']
})
export class PaymentPartnerIframeDialogComponent implements OnInit {
  redirectionUrl:any;
  timer:any;
  @ViewChild('iframe') iframe: ElementRef;
  constructor(
    private dialogRef: MatDialogRef<PaymentPartnerIframeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.redirectionUrl = this.data?.redirectionUrl;
  }

  iframeLoaded() {
    if(this.data?.productType == "EARLY_SALARY" || this.data?.productType == "PHONEPE") {
      setTimeout(() => {
        this.timer = setInterval(() => {
          try{
            if(this.iframe?.nativeElement?.contentWindow?.location?.href) {
              clearInterval(this.timer);
              this.dialogRef.close();
            }
          } catch(error) {
          }
        }, 3000);
      }, 3000);
    }
  }

  closeDialog() {
    if(this.data?.productType == "EARLY_SALARY" || this.data?.productType == "PHONEPE") {
      clearInterval(this.timer);
    }
    this.dialogRef.close();
  }

}
